export const FETCH_MANAGER_REQUEST = 'FETCH_MANAGER_REQUEST';
export const FETCH_MANAGER_SUCCESS = 'FETCH_MANAGER_SUCCESS';
export const FETCH_MANAGER_FAILURE = 'FETCH_MANAGER_FAILURE';

